module.exports = __webpack_public_path__ + "static/mobLandingBG-ed4bffe3831ed7eaa70d4d55b19d149f.jpg";